import React, { useEffect, useMemo, useState } from 'react';
import './TeamGrid.css';
import { useApi } from 'hooks/useApi';

const Leadership = () => {
  const [loading, setLoading] = useState(true);
// Environment variable for CMS base URL
    const CMS_BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

    const fallbackPlaceholder = 'Assets/Images/Whoweare/placeholder.svg';
    const linkedin = 'Assets/Images/Whoweare/Linkedin.svg';
    // Use the useApi hook
    const { data: leadershipData, loadingdata, error } = useApi('/leadership');
    const teamMembers = useMemo(() => {
       
        if (!leadershipData?.results) return [];
        return leadershipData.results
          // .filter(member => member.status === 'active')
          .filter(member => member.status === 'Y')
          .map((member) => ({
            id: member.id,
            name: member.title,
            designation: member.designation,
            role: member.designation,
            company:member.company,
            linkedin_link: member.linkedin_link,
            note: member.note,
            image: member.image ? `${CMS_BASE_URL}/attachments/${member.image}` : fallbackPlaceholder,
            isFeatured: true
          }));
      }, [leadershipData, CMS_BASE_URL]);
  useEffect(() => {
    if (leadershipData?.results) setLoading(false)
  }, [leadershipData]);

  if (loading) {
    return <p style={{ textAlign: 'center' }}>Loading team members...</p>;
  }

  return (
    <div className="team-grid">
        <div className="teamSection">
        <h2 className="teamHeading">
          Our Leadership Team
        </h2>
        <p className="teamSubheading">
          We owe so much of what we've built to the incredible people leading the way. 
          Our leadership team brings a mix of experience, vision, and heart to everything we do. 
          They set the tone, inspire our teams, and keep us moving forward with purpose and passion.
          Together, we make big things happen while staying grounded in what matters most.
        </p>
        
      </div>
        {teamMembers.map((member, index) => (
            <div className="team-card" key={index}>
            <div className="team-image-container">
                <img src={member.image} alt={member.name} className="team-image" />
            </div>
            <div className="team-text">
                <h4 className="team-name">{member.name}</h4>
                <p className="team-company">{member.company}</p>
                <p className="team-role">{member.designation || member.role}</p>
                
            </div>
            <div className="linkedin-wrapper">
                {member.linkedin_link && (
                    <a
                    href={member.linkedin_link}
                    className="linkedin-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    {/* <FaLinkedin size={30} /> */}
                    <img src={linkedin} alt="LinkedIn" className="linkedin-circle-icon" />
                    </a>
                )}
            </div>
            </div>
        ))}
    </div>
  );
};

export default Leadership;
